import { rem } from 'polished'
import styled from 'styled-components'
import tw from 'twin.macro'

export const Tr = styled.tr`
  ${tw`py-5 sm:py-0 block sm:table-row`};

  & > td {
    ${tw`py-0 sm:py-4 px-4 grid gap-x-2 grid-cols-2 sm:table-cell`};
  }

  & > td span[aria-hidden='true'] {
    ${tw`pr-1 sm:hidden`};
  }
`

export const ExpandButton = styled.button`
  ${tw`flex gap-x-2 items-center justify-center col-span-2 mt-3 sm:mt-0 ml-auto sm:ml-0`};
  color: var(--color-gold);
`

export const ExpandButtonText = styled.span`
  ${tw`block sm:hidden`};
`

export const LineItems = styled.div`
  ${tw`p-4 grid gap-y-4`};
`

export const Caret = styled.div`
  ${tw`inline-flex items-center justify-center`};
  width: ${rem(22)};
  height: ${rem(22)};
  border-radius: ${rem(5)};
  box-shadow: 0 ${rem(2)} ${rem(6)} 0 rgba(0, 0, 0, 0.15);
  transition: background-color 0.2s;
  background-color: ${({ $isOpen }) => ($isOpen ? 'var(--color-gold)' : 'var(--color-white)')};
`

export const CaretIcon = styled.div`
  ${tw`transition transform rotate-180`};
  ${({ $isOpen }) => $isOpen && tw`rotate-0`}
  fill: ${({ $isOpen }) => ($isOpen ? 'var(--color-white)' : 'var(--color-gold)')}
`
